import { isAndroid, isIOS, isSafari } from "../browser"
import { AESDecrypt, AESEncrypt, AesCBCDecryptV3 } from "../utils/secureUtil"
export const EVT_PAGE_VISITED = 10001
export const EVT_PAGE_LOADING = 10002
export const EVT_PAGE_STAYING = 10003
export const EVT_ITEM_EXPOSED = 10004
export const EVT_CLICK = 10100

const APP_NAME = getCookie("appName") || "eufy security"

const DEBUG_KEY = "[JSBridge Mock]: "

function log(tmpl, ...params) {
  console.log(
    [
      DEBUG_KEY,
      tmpl.replace(/%s/g, () => {
        const i = params.shift()
        if (typeof i === "object") {
          return JSON.stringify(i, null, 2)
        }
        return i
      }),
    ].join("")
  )
}

const BabyHistory = {
  station_sn: "T8340P002146005B",
  device_sn: "T8340P002146005B",
  baby_id: 3964,
  history_data: {
    startTime: 1686192600,
    endTime: 1686194700,
    status: 1,
    isNight: 0,
    data: [
      { historyDataValue: [-1, -1, -1], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [-1, -1, -1], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [-1, -1, -1], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [-1, -1, -1], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [-1, -1, -1], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [-1, -1, -1], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [-1, -1, -1], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [-1, -1, -1], isHrAbnormal: 0, sleepStatus: 4 },
      { historyDataValue: [-1, -1, -1], isHrAbnormal: 0, sleepStatus: 4 },
      { historyDataValue: [-1, -1, -1], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [-1, -1, -1], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [-1, -1, -1], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [-1, -1, -1], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [90, 99, 0], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [88, 98, 0], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [75, 98, 0], isHrAbnormal: 1, sleepStatus: 2 },
      { historyDataValue: [74, 99, 0], isHrAbnormal: 1, sleepStatus: 2 },
      { historyDataValue: [76, 99, 0], isHrAbnormal: 1, sleepStatus: 2 },
      { historyDataValue: [85, 98, 0], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [84, 98, 0], isHrAbnormal: 0, sleepStatus: 4 },
      { historyDataValue: [85, 98, 0], isHrAbnormal: 0, sleepStatus: 4 },
      { historyDataValue: [85, 98, 0], isHrAbnormal: 0, sleepStatus: 4 },
      { historyDataValue: [85, 99, 0], isHrAbnormal: 0, sleepStatus: 4 },
      { historyDataValue: [84, 99, 0], isHrAbnormal: 0, sleepStatus: 4 },
      { historyDataValue: [84, 98, 0], isHrAbnormal: 0, sleepStatus: 4 },
      { historyDataValue: [84, 98, 0], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [85, 98, 0], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [85, 98, 0], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [84, 98, 0], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [84, 98, 0], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [85, 99, 0], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [85, 99, 0], isHrAbnormal: 0, sleepStatus: 4 },
      { historyDataValue: [85, 98, 0], isHrAbnormal: 0, sleepStatus: 2 },
      { historyDataValue: [84, 98, 0], isHrAbnormal: 0, sleepStatus: 4 },
      { historyDataValue: [84, 98, 0], isHrAbnormal: 0, sleepStatus: 4 },
    ],
  },
}

/**
 * @param {string} name
 */
function getCookie(name) {
  if (typeof window !== "undefined") {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(";").shift()
  }
  return ""
}

function getQuery(name) {
  const search = window.location.search
  const queryString = search.substring(search.indexOf("?"))
  const parts = queryString.match(new RegExp(`&?${name}=(.+?)(?=&)`))
  return parts.pop().split("&")
}

if (typeof window !== "undefined") {
  // TODO: 将 search 转 query 保存到 localstorage
}

export async function isInApp() {
  if (typeof window === 'undefined') {
    return Promise.resolve({})
  }
  if (isAndroid) {
    return new Promise((resolve, reject) => {
      return resolve(!!window.EufyJS || !!window.top.WebViewJavascriptBridge)
    })
  }
  if (isIOS) {
    return Promise.resolve(!isSafari)
  }
  return Promise.resolve(false)
}

export function track(params) {
  console.log("track")
}

export function uploadHelpEvent(key, helpful, level) {
  console.log("uploadHelpEvent")
}

export function setNavbar(config) {
  console.log(`API setNavbar called with: ${JSON.stringify(config)}`)
  return Promise.resolve()
}

export function setNavbarAsync(config) {
  log(`setNavbarAsync with: %s`, config)
  return Promise.resolve({})
}

export function backToNative() {
  console.log("API backTonative called.")
  return Promise.resolve()
}

export function getAppName() {
  return Promise.resolve(APP_NAME)
}

export function getNativeInfo() {
  return Promise.resolve({
    token:
      getCookie("token") || "60930e862bb98f8083470a8520833354b183399a04cbf1d6",
    email: getCookie("email") || "juliana.zhu@anker.com",
    gtoken: getCookie("gtoken") || "d5bf45001215398d2dd163ac75bdfde2",
    appName: getCookie("appName") || "eufy_mega",
    appVersion: getCookie("appVersion") || "4.8.0",
    domain: getCookie("domain") || "security-app-qa.eufylife.com",
    country: getCookie("country") || "US",
    userInterfaceStyle: getCookie("userInterfaceStyle"),
    aiotToken: getCookie("aiotToken"),
  })
}

export function getDeviceList() {
  return Promise.resolve()
}

export function uploadTrackings(params) {
  console.log("uploadTrackings width data:", params)
}

export function openWebview(url) {
  console.log(`openWebview with url: ${url}`)
  if (!window.__IS_APP__) {
    // 把路径前的schema到#这一段去掉
    const absoluteUrl = url.replace(/^[^#]+#/, "")
    window.location.href = absoluteUrl
    return
  }
  window.location.href = url
}

export function openWebviewWithBridge(url) {
  console.log(`openWebviewWithBridge with url: ${url}`)
  return Promise.resolve()
}

export function openBrowser(url) {
  console.log(`openBrowser with url: ${url}`)
  window.location.href = url
}

export function togglePullToRefresh(isRefreshable) {
  // console.log(`togglePullToRefresh: ${isRefreshable}`)
}

export function getBabyHistory() {
  return Promise.resolve(BabyHistory)
}

export function babyDashboardHistoryBottomNoButtonClicked(config) {
  console.log("babyDashboardHistoryBottomNoButtonClicked", config)
  return Promise.resolve()
}

export function getRealHeartRateInfo() {
  const data = {
    device_sn: "T8340P0021280688",
    endTime: 1683541843,
    heartRateDatas: [
      {
        heartRateDataValue: 65,
        isHrAbnormal: 0,
        timeStamp: 1683369000,
      },
      {
        heartRateDataValue: 65,
        isHrAbnormal: 0,
        timeStamp: 1683369060,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683369120,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683369180,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683369240,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683369300,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683369360,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683369420,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683369480,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683369540,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683369600,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683369660,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683369720,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683369780,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683369840,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683369900,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683369960,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683370020,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370080,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370140,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370200,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370260,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370320,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370380,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370440,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370500,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370560,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370620,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370680,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683370740,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370800,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370860,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370920,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683370980,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683371040,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683371100,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683371160,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683371220,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683371280,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683371340,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683371400,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683371460,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683371520,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683371580,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683371640,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683371700,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683371760,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683371820,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683371880,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683371940,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683372000,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683372060,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683372120,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683372180,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683372240,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683372300,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683372360,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683372420,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683372480,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683372540,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683372600,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683372660,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683372720,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683372780,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683372840,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683372900,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683372960,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683373020,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683373080,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683373140,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683373200,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683373260,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683373320,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683373380,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683373440,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683373500,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683373560,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683373620,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683373680,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683373740,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683373800,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683373860,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683373920,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683373980,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683374040,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683374100,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683374160,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683374220,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683374280,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683374340,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683374400,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683374460,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683374520,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683374580,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683374640,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683374700,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683374760,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683374820,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683374880,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683374940,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683375000,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683375060,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683375120,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683375180,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683375240,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683375300,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683375360,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683375420,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683375480,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683375540,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683375600,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683375660,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683375720,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683375780,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683375840,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683375900,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683375960,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683376020,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683376080,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683376140,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683376200,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683376260,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683376320,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683376380,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683376440,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683376500,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683376560,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683376620,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683376680,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683376740,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683376800,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683376860,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683376920,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683376980,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683377040,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683377100,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683377160,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683377220,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683377280,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683377340,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683377400,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683377460,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683377520,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683377580,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683377640,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683377700,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683377760,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683377820,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683377880,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683377940,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378000,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378060,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378120,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378180,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683378240,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683378300,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378360,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378420,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378480,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378540,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378600,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378660,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378720,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378780,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378840,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378900,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683378960,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379020,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379080,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379140,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379200,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379260,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379320,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379380,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379440,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379500,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379560,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379620,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379680,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683379740,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683379800,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379860,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379920,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683379980,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683380040,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683380100,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683380160,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683380220,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683380280,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683380340,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683380400,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683380460,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683380520,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683380580,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683380640,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683380700,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683380760,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683380820,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683380880,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683380940,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683381000,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683381060,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683381120,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683381180,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683381240,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683381300,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683381360,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683381420,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683381480,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683381540,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683381600,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683381660,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683381720,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683381780,
      },
      {
        heartRateDataValue: 74,
        isHrAbnormal: 0,
        timeStamp: 1683381840,
      },
      {
        heartRateDataValue: 75,
        isHrAbnormal: 0,
        timeStamp: 1683381900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683381960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683382980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683383940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683384960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683385980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683386940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683387960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683388980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683389940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683390960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683391980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683392940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683393960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683394980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683395940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683396960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683397980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683398940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683399960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683400980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683401940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683402960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683403980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683404940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683405960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683406980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683407940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683408960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683409980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683410940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683411960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683412980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683413940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683414960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683415980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683416940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683417000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683417060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683417120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683417180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683417240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683417300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683417360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683417420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683417480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683417540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683504960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683505980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683506940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683507960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683508980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683509940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683510960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683511980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683512940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683513960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683514980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683515940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683516960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683517980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683518940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683519960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683520980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683521940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683522960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683523980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683524940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683525960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683526980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683527940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683528000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683528060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683528120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683528180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683528240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683528300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683528360,
      },
      {
        heartRateDataValue: 84,
        isHrAbnormal: 0,
        timeStamp: 1683528420,
      },
      {
        heartRateDataValue: 84,
        isHrAbnormal: 0,
        timeStamp: 1683528480,
      },
      {
        heartRateDataValue: 85,
        isHrAbnormal: 0,
        timeStamp: 1683528540,
      },
      {
        heartRateDataValue: 85,
        isHrAbnormal: 0,
        timeStamp: 1683528600,
      },
      {
        heartRateDataValue: 84,
        isHrAbnormal: 0,
        timeStamp: 1683528660,
      },
      {
        heartRateDataValue: 95,
        isHrAbnormal: 0,
        timeStamp: 1683528720,
      },
      {
        heartRateDataValue: 111,
        isHrAbnormal: 0,
        timeStamp: 1683528780,
      },
      {
        heartRateDataValue: 125,
        isHrAbnormal: 0,
        timeStamp: 1683528840,
      },
      {
        heartRateDataValue: 144,
        isHrAbnormal: 0,
        timeStamp: 1683528900,
      },
      {
        heartRateDataValue: 152,
        isHrAbnormal: 0,
        timeStamp: 1683528960,
      },
      {
        heartRateDataValue: 176,
        isHrAbnormal: 0,
        timeStamp: 1683529020,
      },
      {
        heartRateDataValue: 182,
        isHrAbnormal: 0,
        timeStamp: 1683529080,
      },
      {
        heartRateDataValue: 191,
        isHrAbnormal: 0,
        timeStamp: 1683529140,
      },
      {
        heartRateDataValue: 199,
        isHrAbnormal: 0,
        timeStamp: 1683529200,
      },
      {
        heartRateDataValue: 208,
        isHrAbnormal: 0,
        timeStamp: 1683529260,
      },
      {
        heartRateDataValue: 210,
        isHrAbnormal: 0,
        timeStamp: 1683529320,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683529380,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683529440,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683529500,
      },
      {
        heartRateDataValue: 210,
        isHrAbnormal: 0,
        timeStamp: 1683529560,
      },
      {
        heartRateDataValue: 210,
        isHrAbnormal: 0,
        timeStamp: 1683529620,
      },
      {
        heartRateDataValue: 210,
        isHrAbnormal: 0,
        timeStamp: 1683529680,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683529740,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683529800,
      },
      {
        heartRateDataValue: 210,
        isHrAbnormal: 0,
        timeStamp: 1683529860,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683529920,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683529980,
      },
      {
        heartRateDataValue: 210,
        isHrAbnormal: 0,
        timeStamp: 1683530040,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683530100,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683530160,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683530220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683530280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683530340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683530400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683530460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683530520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683530580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683530640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683530700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683530760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683530820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683530880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683530940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683531960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683532020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683532080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683532140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683532200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683532260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683532320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683532380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683532440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683532500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683532560,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683532620,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683532680,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683532740,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683532800,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683532860,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683532920,
      },
      {
        heartRateDataValue: 210,
        isHrAbnormal: 0,
        timeStamp: 1683532980,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683533040,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683533100,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683533160,
      },
      {
        heartRateDataValue: 210,
        isHrAbnormal: 0,
        timeStamp: 1683533220,
      },
      {
        heartRateDataValue: 210,
        isHrAbnormal: 0,
        timeStamp: 1683533280,
      },
      {
        heartRateDataValue: 210,
        isHrAbnormal: 0,
        timeStamp: 1683533340,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683533400,
      },
      {
        heartRateDataValue: 209,
        isHrAbnormal: 0,
        timeStamp: 1683533460,
      },
      {
        heartRateDataValue: 210,
        isHrAbnormal: 0,
        timeStamp: 1683533520,
      },
      {
        heartRateDataValue: 211,
        isHrAbnormal: 0,
        timeStamp: 1683533580,
      },
      {
        heartRateDataValue: 211,
        isHrAbnormal: 0,
        timeStamp: 1683533640,
      },
      {
        heartRateDataValue: 211,
        isHrAbnormal: 0,
        timeStamp: 1683533700,
      },
      {
        heartRateDataValue: 211,
        isHrAbnormal: 0,
        timeStamp: 1683533760,
      },
      {
        heartRateDataValue: 211,
        isHrAbnormal: 0,
        timeStamp: 1683533820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683533880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683533940,
      },
      {
        heartRateDataValue: 211,
        isHrAbnormal: 0,
        timeStamp: 1683534000,
      },
      {
        heartRateDataValue: 212,
        isHrAbnormal: 0,
        timeStamp: 1683534060,
      },
      {
        heartRateDataValue: 212,
        isHrAbnormal: 0,
        timeStamp: 1683534120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683534180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683534240,
      },
      {
        heartRateDataValue: 212,
        isHrAbnormal: 0,
        timeStamp: 1683534300,
      },
      {
        heartRateDataValue: 212,
        isHrAbnormal: 0,
        timeStamp: 1683534360,
      },
      {
        heartRateDataValue: 212,
        isHrAbnormal: 0,
        timeStamp: 1683534420,
      },
      {
        heartRateDataValue: 212,
        isHrAbnormal: 0,
        timeStamp: 1683534480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683534540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683534600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683534660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683534720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683534780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683534840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683534900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683534960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683535020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683535080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683535140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683535200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683535260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683535320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683535380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683535440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683535500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683535560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683535620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683535680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683535740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683535800,
      },
      {
        heartRateDataValue: 139,
        isHrAbnormal: 0,
        timeStamp: 1683535860,
      },
      {
        heartRateDataValue: 140,
        isHrAbnormal: 0,
        timeStamp: 1683535920,
      },
      {
        heartRateDataValue: 144,
        isHrAbnormal: 0,
        timeStamp: 1683535980,
      },
      {
        heartRateDataValue: 149,
        isHrAbnormal: 0,
        timeStamp: 1683536040,
      },
      {
        heartRateDataValue: 149,
        isHrAbnormal: 0,
        timeStamp: 1683536100,
      },
      {
        heartRateDataValue: 149,
        isHrAbnormal: 0,
        timeStamp: 1683536160,
      },
      {
        heartRateDataValue: 149,
        isHrAbnormal: 0,
        timeStamp: 1683536220,
      },
      {
        heartRateDataValue: 149,
        isHrAbnormal: 0,
        timeStamp: 1683536280,
      },
      {
        heartRateDataValue: 149,
        isHrAbnormal: 0,
        timeStamp: 1683536340,
      },
      {
        heartRateDataValue: 149,
        isHrAbnormal: 0,
        timeStamp: 1683536400,
      },
      {
        heartRateDataValue: 149,
        isHrAbnormal: 0,
        timeStamp: 1683536460,
      },
      {
        heartRateDataValue: 150,
        isHrAbnormal: 0,
        timeStamp: 1683536520,
      },
      {
        heartRateDataValue: 150,
        isHrAbnormal: 0,
        timeStamp: 1683536580,
      },
      {
        heartRateDataValue: 149,
        isHrAbnormal: 0,
        timeStamp: 1683536640,
      },
      {
        heartRateDataValue: 150,
        isHrAbnormal: 0,
        timeStamp: 1683536700,
      },
      {
        heartRateDataValue: 149,
        isHrAbnormal: 0,
        timeStamp: 1683536760,
      },
      {
        heartRateDataValue: 150,
        isHrAbnormal: 0,
        timeStamp: 1683536820,
      },
      {
        heartRateDataValue: 149,
        isHrAbnormal: 0,
        timeStamp: 1683536880,
      },
      {
        heartRateDataValue: 141,
        isHrAbnormal: 0,
        timeStamp: 1683536940,
      },
      {
        heartRateDataValue: 143,
        isHrAbnormal: 0,
        timeStamp: 1683537000,
      },
      {
        heartRateDataValue: 144,
        isHrAbnormal: 0,
        timeStamp: 1683537060,
      },
      {
        heartRateDataValue: 145,
        isHrAbnormal: 0,
        timeStamp: 1683537120,
      },
      {
        heartRateDataValue: 144,
        isHrAbnormal: 0,
        timeStamp: 1683537180,
      },
      {
        heartRateDataValue: 135,
        isHrAbnormal: 0,
        timeStamp: 1683537240,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683537300,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683537360,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683537420,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683537480,
      },
      {
        heartRateDataValue: 135,
        isHrAbnormal: 0,
        timeStamp: 1683537540,
      },
      {
        heartRateDataValue: 135,
        isHrAbnormal: 0,
        timeStamp: 1683537600,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683537660,
      },
      {
        heartRateDataValue: 135,
        isHrAbnormal: 0,
        timeStamp: 1683537720,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683537780,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683537840,
      },
      {
        heartRateDataValue: 135,
        isHrAbnormal: 0,
        timeStamp: 1683537900,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683537960,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683538020,
      },
      {
        heartRateDataValue: 135,
        isHrAbnormal: 0,
        timeStamp: 1683538080,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683538140,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683538200,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683538260,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683538320,
      },
      {
        heartRateDataValue: 135,
        isHrAbnormal: 0,
        timeStamp: 1683538380,
      },
      {
        heartRateDataValue: 135,
        isHrAbnormal: 0,
        timeStamp: 1683538440,
      },
      {
        heartRateDataValue: 135,
        isHrAbnormal: 0,
        timeStamp: 1683538500,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683538560,
      },
      {
        heartRateDataValue: 134,
        isHrAbnormal: 0,
        timeStamp: 1683538620,
      },
      {
        heartRateDataValue: 135,
        isHrAbnormal: 0,
        timeStamp: 1683538680,
      },
      {
        heartRateDataValue: 135,
        isHrAbnormal: 0,
        timeStamp: 1683538740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683538800,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683538860,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683538920,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683538980,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539040,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539100,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539160,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539220,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539280,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539340,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539400,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539460,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539520,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539580,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539640,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539700,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539760,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539820,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539880,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683539940,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540000,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540060,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540120,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540180,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540240,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540300,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540360,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540420,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540480,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540540,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540600,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540660,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540720,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540780,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540840,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540900,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683540960,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683541020,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683541080,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683541140,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683541200,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683541260,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683541320,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683541380,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683541440,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683541500,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683541560,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683541620,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683541680,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683541740,
      },
      {
        heartRateDataValue: 0,
        isHrAbnormal: 0,
        timeStamp: 1683541800,
      },
    ],
    startTime: 1683369043,
    station_sn: "T8351P0021290527",
  }
  return Promise.resolve(data)
}

export function realHeartRateFaqClicked() {
  console.log("click real heart rate faq")
  return Promise.resolve()
}

export function realHeartRateShowErrorUI() {
  console.log("turn to real heart err")
  return Promise.resolve()
}

export function getRealBloodOxygenInfo() {
  const data = {
    bloodOxygenDatas: [
      {
        timeStamp: 1685404800,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685404860,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685404920,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685404980,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685405040,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685405100,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685405160,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685405220,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685405280,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685405340,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685405400,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685405460,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685405520,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685405580,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685405640,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685405700,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685405760,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685405820,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685405880,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685405940,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685406000,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685406060,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685406120,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685406180,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685406240,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685406300,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685406360,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685406420,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685406480,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685406540,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685406600,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685406660,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685406720,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685406780,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685406840,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685406900,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685406960,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685407020,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685407080,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685407140,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685407200,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685407260,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685407320,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685407380,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685407440,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685407500,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685407560,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685407620,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685407680,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685407740,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685407800,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685407860,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685407920,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685407980,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685408040,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685408100,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685408160,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685408220,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685408280,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685408340,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685408400,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685408460,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685408520,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685408580,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685408640,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685408700,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685408760,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685408820,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685408880,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685408940,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685409000,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685409060,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685409120,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685409180,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685409240,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685409300,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685409360,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685409420,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685409480,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685409540,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685409600,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685409660,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685409720,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685409780,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685409840,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685409900,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685409960,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685410020,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685410080,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685410140,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685410200,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685410260,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685410320,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685410380,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685410440,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685410500,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685410560,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685410620,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685410680,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685410740,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685410800,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685410860,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685410920,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685410980,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685411040,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685411100,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685411160,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685411220,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685411280,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685411340,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685411400,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685411460,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685411520,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685411580,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685411640,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685411700,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685411760,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685411820,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685411880,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685411940,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685412000,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685412060,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685412120,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685412180,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685412240,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685412300,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685412360,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685412420,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685412480,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685412540,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685412600,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685412660,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685412720,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685412780,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685412840,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685412900,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685412960,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685413020,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685413080,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685413140,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685413200,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685413260,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685413320,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685413380,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685413440,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685413500,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685413560,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685413620,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685413680,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685413740,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685413800,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685413860,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685413920,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685413980,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685414040,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685414100,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685414160,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685414220,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685414280,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685414340,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685414400,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685414460,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685414520,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685414580,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685414640,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685414700,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685414760,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685414820,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685414880,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685414940,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685415000,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685415060,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685415120,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685415180,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685415240,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685415300,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685415360,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685415420,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685415480,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685415540,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685415600,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685415660,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685415720,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685415780,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685415840,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685415900,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685415960,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685416020,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685416080,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685416140,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685416200,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685416260,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685416320,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685416380,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685416440,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685416500,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685416560,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685416620,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685416680,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685416740,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685416800,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685416860,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685416920,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685416980,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685417040,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685417100,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685417160,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685417220,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685417280,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685417340,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685417400,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685417460,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685417520,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685417580,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685417640,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685417700,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685417760,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685417820,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685417880,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685417940,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685418000,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685418060,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685418120,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685418180,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685418240,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685418300,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685418360,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685418420,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685418480,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685418540,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685418600,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685418660,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685418720,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685418780,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685418840,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685418900,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685418960,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685419020,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685419080,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685419140,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685419200,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685419260,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685419320,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685419380,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685419440,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685419500,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685419560,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685419620,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685419680,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685419740,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685419800,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685419860,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685419920,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685419980,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685420040,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685420100,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685420160,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685420220,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685420280,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685420340,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685420400,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685420460,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685420520,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685420580,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685420640,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685420700,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685420760,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685420820,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685420880,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685420940,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685421000,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685421060,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685421120,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685421180,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685421240,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685421300,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685421360,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685421420,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685421480,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685421540,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685421600,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685421660,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685421720,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685421780,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685421840,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685421900,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685421960,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685422020,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685422080,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685422140,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685422200,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685422260,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685422320,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685422380,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685422440,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685422500,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685422560,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685422620,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685422680,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685422740,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685422800,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685422860,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685422920,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685422980,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685423040,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685423100,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685423160,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685423220,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685423280,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685423340,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685423400,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685423460,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685423520,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685423580,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685423640,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685423700,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685423760,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685423820,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685423880,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685423940,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685424000,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685424060,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685424120,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685424180,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685424240,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685424300,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685424360,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685424420,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685424480,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685424540,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685424600,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685424660,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685424720,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685424780,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685424840,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685424900,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685424960,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685425020,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685425080,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685425140,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685425200,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685425260,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685425320,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685425380,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685425440,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685425500,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685425560,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685425620,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685425680,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685425740,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685425800,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685425860,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685425920,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685425980,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685426040,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685426100,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685426160,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685426220,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685426280,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685426340,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685426400,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685426460,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685426520,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685426580,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685426640,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685426700,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685426760,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685426820,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685426880,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685426940,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685427000,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685427060,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685427120,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685427180,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685427240,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685427300,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685427360,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685427420,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685427480,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685427540,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685427600,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685427660,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685427720,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685427780,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685427840,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685427900,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685427960,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685428020,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685428080,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685428140,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685428200,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685428260,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685428320,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685428380,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685428440,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685428500,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685428560,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685428620,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685428680,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685428740,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685428800,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685428860,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685428920,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685428980,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685429040,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685429100,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685429160,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685429220,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685429280,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685429340,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685429400,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685429460,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685429520,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685429580,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685429640,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685429700,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685429760,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685429820,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685429880,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685429940,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685430000,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685430060,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685430120,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685430180,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685430240,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685430300,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685430360,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685430420,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685430480,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685430540,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685430600,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685430660,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685430720,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685430780,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685430840,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685430900,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685430960,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685431020,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685431080,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685431140,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685431200,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685431260,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685431320,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685431380,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685431440,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685431500,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685431560,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685431620,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685431680,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685431740,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685431800,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685431860,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685431920,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685431980,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685432040,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685432100,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685432160,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685432220,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685432280,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685432340,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685432400,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685432460,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685432520,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685432580,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685432640,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685432700,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685432760,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685432820,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685432880,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685432940,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685433000,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685433060,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685433120,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685433180,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685433240,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685433300,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685433360,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685433420,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685433480,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685433540,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685433600,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685433660,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685433720,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685433780,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685433840,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685433900,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685433960,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685434020,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685434080,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685434140,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685434200,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685434260,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685434320,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685434380,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685434440,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685434500,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685434560,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685434620,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685434680,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685434740,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685434800,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685434860,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685434920,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685434980,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685435040,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685435100,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685435160,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685435220,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685435280,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685435340,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685435400,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685435460,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685435520,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685435580,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685435640,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685435700,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685435760,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685435820,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685435880,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685435940,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685436000,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685436060,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685436120,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685436180,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685436240,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685436300,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685436360,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685436420,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685436480,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685436540,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685436600,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685436660,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685436720,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685436780,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685436840,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685436900,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685436960,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685437020,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685437080,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685437140,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685437200,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685437260,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685437320,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685437380,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685437440,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685437500,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685437560,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685437620,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685437680,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685437740,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685437800,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685437860,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685437920,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685437980,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685438040,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685438100,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685438160,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685438220,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685438280,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685438340,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685438400,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685438460,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685438520,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685438580,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685438640,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685438700,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685438760,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685438820,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685438880,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685438940,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685439000,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685439060,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685439120,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685439180,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685439240,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685439300,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685439360,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685439420,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685439480,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685439540,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685439600,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685439660,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685439720,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685439780,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685439840,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685439900,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685439960,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685440020,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685440080,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685440140,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685440200,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685440260,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685440320,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685440380,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685440440,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685440500,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685440560,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685440620,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685440680,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685440740,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685440800,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685440860,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685440920,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685440980,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685441040,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685441100,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685441160,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685441220,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685441280,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685441340,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685441400,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685441460,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685441520,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685441580,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685441640,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685441700,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685441760,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685441820,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685441880,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685441940,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685442000,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685442060,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685442120,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685442180,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685442240,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685442300,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685442360,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685442420,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685442480,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685442540,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685442600,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685442660,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685442720,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685442780,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685442840,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685442900,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685442960,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685443020,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685443080,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685443140,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685443200,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685443260,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685443320,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685443380,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685443440,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685443500,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685443560,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685443620,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685443680,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685443740,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685443800,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685443860,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685443920,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685443980,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685444040,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685444100,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685444160,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685444220,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685444280,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685444340,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685444400,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685444460,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685444520,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685444580,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685444640,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685444700,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685444760,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685444820,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685444880,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685444940,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685445000,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685445060,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685445120,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685445180,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685445240,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685445300,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685445360,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685445420,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685445480,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685445540,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685445600,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685445660,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685445720,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685445780,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685445840,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685445900,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685445960,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685446020,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685446080,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685446140,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685446200,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685446260,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685446320,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685446380,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685446440,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685446500,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685446560,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685446620,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685446680,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685446740,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685446800,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685446860,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685446920,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685446980,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685447040,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685447100,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685447160,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685447220,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685447280,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685447340,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685447400,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685447460,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685447520,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685447580,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685447640,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685447700,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685447760,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685447820,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685447880,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685447940,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685448000,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685448060,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685448120,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685448180,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685448240,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685448300,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685448360,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685448420,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685448480,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685448540,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685448600,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685448660,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685448720,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685448780,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685448840,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685448900,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685448960,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685449020,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685449080,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685449140,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685449200,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685449260,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685449320,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685449380,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685449440,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685449500,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685449560,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685449620,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685449680,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685449740,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685449800,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685449860,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685449920,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685449980,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685450040,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685450100,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685450160,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685450220,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685450280,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685450340,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685450400,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685450460,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685450520,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685450580,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685450640,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685450700,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685450760,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685450820,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685450880,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685450940,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685451000,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685451060,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685451120,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685451180,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685451240,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685451300,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685451360,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685451420,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685451480,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685451540,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685451600,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685451660,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685451720,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685451780,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685451840,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685451900,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685451960,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685452020,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685452080,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685452140,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685452200,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685452260,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685452320,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685452380,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685452440,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685452500,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685452560,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685452620,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685452680,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685452740,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685452800,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685452860,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685452920,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685452980,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685453040,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685453100,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685453160,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685453220,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685453280,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685453340,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685453400,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685453460,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685453520,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685453580,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685453640,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685453700,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685453760,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685453820,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685453880,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685453940,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685454000,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685454060,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685454120,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685454180,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685454240,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685454300,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685454360,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685454420,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685454480,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685454540,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685454600,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685454660,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685454720,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685454780,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685454840,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685454900,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685454960,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685455020,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685455080,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685455140,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685455200,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685455260,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685455320,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685455380,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685455440,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685455500,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685455560,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685455620,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685455680,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685455740,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685455800,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685455860,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685455920,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685455980,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685456040,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685456100,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685456160,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685456220,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685456280,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685456340,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685456400,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685456460,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685456520,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685456580,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685456640,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685456700,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685456760,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685456820,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685456880,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685456940,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685457000,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685457060,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685457120,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685457180,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685457240,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685457300,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685457360,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685457420,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685457480,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685457540,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685457600,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685457660,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685457720,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685457780,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685457840,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685457900,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685457960,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685458020,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685458080,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685458140,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685458200,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685458260,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685458320,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685458380,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685458440,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685458500,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685458560,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685458620,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685458680,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685458740,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685458800,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685458860,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685458920,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685458980,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685459040,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685459100,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685459160,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685459220,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685459280,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685459340,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685459400,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685459460,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685459520,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685459580,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685459640,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685459700,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685459760,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685459820,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685459880,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685459940,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685460000,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685460060,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685460120,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685460180,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685460240,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685460300,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685460360,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685460420,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685460480,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685460540,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685460600,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685460660,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685460720,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685460780,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685460840,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685460900,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685460960,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685461020,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685461080,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685461140,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685461200,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685461260,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685461320,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685461380,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685461440,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685461500,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685461560,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685461620,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685461680,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685461740,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685461800,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685461860,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685461920,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685461980,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685462040,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685462100,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685462160,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685462220,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685462280,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685462340,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685462400,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685462460,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685462520,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685462580,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685462640,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685462700,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685462760,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685462820,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685462880,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685462940,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685463000,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685463060,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685463120,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685463180,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685463240,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685463300,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685463360,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685463420,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685463480,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685463540,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685463600,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685463660,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685463720,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685463780,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685463840,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685463900,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685463960,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685464020,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685464080,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685464140,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685464200,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685464260,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685464320,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685464380,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685464440,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685464500,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685464560,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685464620,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685464680,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685464740,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685464800,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685464860,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685464920,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685464980,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685465040,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685465100,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685465160,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685465220,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685465280,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685465340,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685465400,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685465460,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685465520,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685465580,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685465640,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685465700,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685465760,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685465820,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685465880,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685465940,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685466000,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685466060,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685466120,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685466180,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685466240,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685466300,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685466360,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685466420,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685466480,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685466540,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685466600,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685466660,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685466720,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685466780,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685466840,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685466900,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685466960,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685467020,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685467080,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685467140,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685467200,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685467260,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685467320,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685467380,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685467440,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685467500,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685467560,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685467620,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685467680,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685467740,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685467800,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685467860,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685467920,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685467980,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685468040,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685468100,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685468160,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685468220,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685468280,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685468340,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685468400,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685468460,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685468520,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685468580,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685468640,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685468700,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685468760,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685468820,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685468880,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685468940,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685469000,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685469060,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685469120,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685469180,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685469240,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685469300,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685469360,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685469420,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685469480,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685469540,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685469600,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685469660,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685469720,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685469780,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685469840,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685469900,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685469960,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685470020,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685470080,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685470140,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685470200,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685470260,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685470320,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685470380,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685470440,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685470500,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685470560,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685470620,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685470680,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685470740,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685470800,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685470860,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685470920,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685470980,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685471040,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685471100,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685471160,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685471220,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685471280,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685471340,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685471400,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685471460,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685471520,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685471580,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685471640,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685471700,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685471760,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685471820,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685471880,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685471940,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685472000,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685472060,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685472120,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685472180,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685472240,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685472300,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685472360,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685472420,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685472480,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685472540,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685472600,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685472660,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685472720,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685472780,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685472840,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685472900,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685472960,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685473020,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685473080,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685473140,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685473200,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685473260,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685473320,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685473380,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685473440,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685473500,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685473560,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685473620,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685473680,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685473740,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685473800,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685473860,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685473920,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685473980,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685474040,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685474100,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685474160,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685474220,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685474280,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685474340,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685474400,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685474460,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685474520,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685474580,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685474640,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685474700,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685474760,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685474820,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685474880,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685474940,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685475000,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685475060,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685475120,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685475180,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685475240,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685475300,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685475360,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685475420,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685475480,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685475540,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685475600,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685475660,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685475720,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685475780,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685475840,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685475900,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685475960,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685476020,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685476080,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685476140,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685476200,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685476260,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685476320,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685476380,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685476440,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685476500,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685476560,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685476620,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685476680,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685476740,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685476800,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685476860,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685476920,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685476980,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685477040,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685477100,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685477160,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685477220,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685477280,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685477340,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685477400,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685477460,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685477520,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685477580,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685477640,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685477700,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685477760,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685477820,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685477880,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685477940,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685478000,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685478060,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685478120,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685478180,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685478240,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685478300,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685478360,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685478420,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685478480,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685478540,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685478600,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685478660,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685478720,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685478780,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685478840,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685478900,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685478960,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685479020,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685479080,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685479140,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685479200,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685479260,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685479320,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685479380,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685479440,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685479500,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685479560,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685479620,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685479680,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685479740,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685479800,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685479860,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685479920,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685479980,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685480040,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685480100,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685480160,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685480220,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685480280,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685480340,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685480400,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685480460,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685480520,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685480580,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685480640,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685480700,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685480760,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685480820,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685480880,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685480940,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685481000,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685481060,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685481120,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685481180,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685481240,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685481300,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685481360,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685481420,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685481480,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685481540,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685481600,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685481660,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685481720,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685481780,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685481840,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685481900,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685481960,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685482020,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685482080,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685482140,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685482200,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685482260,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685482320,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685482380,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685482440,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685482500,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685482560,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685482620,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685482680,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685482740,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685482800,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685482860,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685482920,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685482980,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685483040,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685483100,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685483160,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685483220,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685483280,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685483340,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685483400,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685483460,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685483520,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685483580,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685483640,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685483700,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685483760,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685483820,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685483880,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685483940,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685484000,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685484060,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685484120,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685484180,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685484240,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685484300,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685484360,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685484420,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685484480,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685484540,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685484600,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685484660,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685484720,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685484780,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685484840,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685484900,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685484960,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685485020,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685485080,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685485140,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685485200,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685485260,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685485320,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685485380,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685485440,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685485500,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685485560,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685485620,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685485680,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685485740,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685485800,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685485860,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685485920,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685485980,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685486040,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685486100,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685486160,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685486220,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685486280,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685486340,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685486400,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685486460,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685486520,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685486580,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685486640,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685486700,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685486760,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685486820,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685486880,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685486940,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685487000,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685487060,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685487120,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685487180,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685487240,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685487300,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685487360,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685487420,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685487480,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685487540,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685487600,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685487660,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685487720,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685487780,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685487840,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685487900,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685487960,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685488020,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685488080,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685488140,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685488200,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685488260,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685488320,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685488380,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685488440,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685488500,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685488560,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685488620,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685488680,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685488740,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685488800,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685488860,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685488920,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685488980,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685489040,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685489100,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685489160,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685489220,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685489280,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685489340,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685489400,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685489460,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685489520,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685489580,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685489640,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685489700,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685489760,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685489820,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685489880,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685489940,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685490000,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685490060,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685490120,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685490180,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685490240,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685490300,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685490360,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685490420,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685490480,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685490540,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685490600,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685490660,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685490720,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685490780,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685490840,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685490900,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685490960,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685491020,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685491080,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685491140,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685491200,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685491260,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685491320,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685491380,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685491440,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685491500,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685491560,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685491620,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685491680,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685491740,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685491800,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685491860,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685491920,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685491980,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685492040,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685492100,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685492160,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685492220,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685492280,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685492340,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685492400,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685492460,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685492520,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685492580,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685492640,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685492700,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685492760,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685492820,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685492880,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685492940,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685493000,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685493060,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685493120,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685493180,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685493240,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685493300,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685493360,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685493420,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685493480,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685493540,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685493600,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685493660,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685493720,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685493780,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685493840,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685493900,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685493960,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685494020,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685494080,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685494140,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685494200,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685494260,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685494320,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685494380,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685494440,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685494500,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685494560,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685494620,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685494680,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685494740,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685494800,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685494860,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685494920,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685494980,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685495040,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685495100,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685495160,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685495220,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685495280,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685495340,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685495400,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685495460,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685495520,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685495580,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685495640,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685495700,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685495760,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685495820,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685495880,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685495940,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685496000,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685496060,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685496120,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685496180,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685496240,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685496300,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685496360,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685496420,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685496480,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685496540,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685496600,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685496660,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685496720,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685496780,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685496840,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685496900,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685496960,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685497020,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685497080,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685497140,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685497200,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685497260,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685497320,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685497380,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685497440,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685497500,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685497560,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685497620,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685497680,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685497740,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685497800,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685497860,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685497920,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685497980,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685498040,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685498100,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685498160,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685498220,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685498280,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685498340,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685498400,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685498460,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685498520,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685498580,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685498640,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685498700,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685498760,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685498820,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685498880,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685498940,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685499000,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685499060,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685499120,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685499180,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685499240,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685499300,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685499360,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685499420,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685499480,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685499540,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685499600,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685499660,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685499720,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685499780,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685499840,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685499900,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685499960,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685500020,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685500080,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685500140,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685500200,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685500260,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685500320,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685500380,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685500440,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685500500,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685500560,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685500620,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685500680,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685500740,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685500800,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685500860,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685500920,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685500980,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685501040,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685501100,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685501160,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685501220,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685501280,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685501340,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685501400,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685501460,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685501520,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685501580,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685501640,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685501700,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685501760,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685501820,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685501880,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685501940,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685502000,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685502060,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685502120,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685502180,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685502240,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685502300,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685502360,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685502420,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685502480,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685502540,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685502600,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685502660,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685502720,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685502780,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685502840,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685502900,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685502960,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685503020,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685503080,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685503140,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685503200,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685503260,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685503320,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685503380,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685503440,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685503500,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685503560,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685503620,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685503680,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685503740,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685503800,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685503860,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685503920,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685503980,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685504040,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685504100,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685504160,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685504220,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685504280,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685504340,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685504400,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685504460,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685504520,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685504580,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685504640,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685504700,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685504760,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685504820,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685504880,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685504940,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685505000,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685505060,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685505120,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685505180,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685505240,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685505300,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685505360,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685505420,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685505480,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685505540,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685505600,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685505660,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685505720,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685505780,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685505840,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685505900,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685505960,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685506020,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685506080,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685506140,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685506200,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685506260,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685506320,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685506380,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685506440,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685506500,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685506560,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685506620,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685506680,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685506740,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685506800,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685506860,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685506920,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685506980,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685507040,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685507100,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685507160,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685507220,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685507280,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685507340,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685507400,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685507460,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685507520,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685507580,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685507640,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685507700,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685507760,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685507820,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685507880,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685507940,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685508000,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685508060,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685508120,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685508180,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685508240,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685508300,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685508360,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685508420,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685508480,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685508540,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685508600,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685508660,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685508720,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685508780,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685508840,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685508900,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685508960,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685509020,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685509080,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685509140,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685509200,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685509260,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685509320,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685509380,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685509440,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685509500,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685509560,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685509620,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685509680,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685509740,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685509800,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685509860,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685509920,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685509980,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685510040,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685510100,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685510160,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685510220,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685510280,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685510340,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685510400,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685510460,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685510520,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685510580,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685510640,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685510700,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685510760,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685510820,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685510880,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685510940,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685511000,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685511060,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685511120,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685511180,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685511240,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685511300,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685511360,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685511420,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685511480,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685511540,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685511600,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685511660,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685511720,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685511780,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685511840,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685511900,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685511960,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685512020,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685512080,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685512140,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685512200,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685512260,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685512320,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685512380,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685512440,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685512500,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685512560,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685512620,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685512680,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685512740,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685512800,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685512860,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685512920,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685512980,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685513040,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685513100,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685513160,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685513220,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685513280,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685513340,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685513400,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685513460,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685513520,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685513580,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685513640,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685513700,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685513760,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685513820,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685513880,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685513940,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685514000,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685514060,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685514120,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685514180,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685514240,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685514300,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685514360,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685514420,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685514480,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685514540,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685514600,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685514660,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685514720,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685514780,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685514840,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685514900,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685514960,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685515020,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685515080,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685515140,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685515200,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685515260,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685515320,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685515380,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685515440,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685515500,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685515560,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685515620,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685515680,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685515740,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685515800,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685515860,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685515920,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685515980,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685516040,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685516100,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685516160,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685516220,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685516280,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685516340,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685516400,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685516460,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685516520,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685516580,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685516640,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685516700,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685516760,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685516820,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685516880,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685516940,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685517000,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685517060,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685517120,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685517180,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685517240,
        bloodOxygenDataValue: 93,
      },
      {
        timeStamp: 1685517300,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685517360,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685517420,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685517480,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685517540,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685517600,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685517660,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685517720,
        bloodOxygenDataValue: 92,
      },
      {
        timeStamp: 1685517780,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685517840,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685517900,
        bloodOxygenDataValue: 97,
      },
      {
        timeStamp: 1685517960,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685518020,
        bloodOxygenDataValue: 95,
      },
      {
        timeStamp: 1685518080,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685518140,
        bloodOxygenDataValue: 99,
      },
      {
        timeStamp: 1685518200,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685518260,
        bloodOxygenDataValue: 98,
      },
      {
        timeStamp: 1685518320,
        bloodOxygenDataValue: 94,
      },
      {
        timeStamp: 1685518380,
        bloodOxygenDataValue: 91,
      },
      {
        timeStamp: 1685518440,
        bloodOxygenDataValue: 96,
      },
      {
        timeStamp: 1685518500,
        bloodOxygenDataValue: 91,
      },
    ],
    device_sn: "T8340P0021460061",
    endTime: 1685518519,
    startTime: 1685345719,
    station_sn: "T8351P00214203DC",
  }
  return Promise.resolve(data)
}

export function realBloodOxygenFaqClicked() {
  console.log("click real blood oxygen faq")
  return Promise.resolve()
}

export function realBloodOxygenShowErrorUI() {
  console.log("turn to real blood oxygen err")
  return Promise.resolve()
}

export async function encrypt(data) {
  log("encrypt: %s", data)
  return await AESEncrypt(data.data)
}

export async function decrypt(data) {
  console.log("decrypt: %s", data)
  let res
  try {
    res = JSON.parse(await AESDecrypt(data.data))
  } catch (e) {
    console.error(e)
  }
  return res
}

export function exitApp() {
  console.log("click exitApp")
  return Promise.resolve()
}

export function readAgreement() {
  console.log("click readAgreement")
  return Promise.resolve()
}

export function startAddDevice() {
  console.log("click startAddDevice")
  return Promise.resolve()
}

export function navigateRN(parmas) {
  console.log("click navigateRN", parmas)
  return Promise.resolve({ code: 0 })
}

export async function getHeaderV3(data) {
  log("getHeaderV3: %s", data)
}

export async function encryptV3(data) {
  console.log("encryptV3: %s", data)
  log("encryptV3: %s", data)
}
export async function decryptV3App(data) {
  log("decryptV3App: %s", data)
}
export async function decryptV3H5(data, shareKey) {
  if (!data) {
    return data
  }
  const decryptjson = await AesCBCDecryptV3(data, shareKey)
  try {
    return JSON.parse(decryptjson)
  } catch (error) {
    return decryptjson
  }
}
export function successfulWarrantySubmissions() {
  console.log("click successfulWarrantySubmissions")
  return Promise.resolve()
}

export function uploadTrackingsForClean(params) {
  console.log("uploadTrackingsForClean width data:", params)
}

export function appLoginOut() {
  console.log("click appLoginOut")
  return Promise.resolve()
}
export function showGoToRestrictedZone() {
  console.log("call showGoToRestrictedZone")
  return true
}
export function pageAction(action) {
  console.log("call pageAction",action)
  return Promise.resolve()
}
export function getAgreementsInfo() {
  console.log("call getAgreementsInfo mock native")
  const data = {"volcengine_copywriting":{"agreement_decline":"Decline","agreement_update_text_for_allapp":"We\u0027ve revised our \u003c0\u003e{agreement_name}\u003c/0\u003e. By continuing to use our services, you acknowledge and agree to our terms and policies. Please take a few minutes to review and understand them.","agreement_sign_up":"I agree to the \u003c0\u003e\u003c0\u003e{agreement_name}\u003c/0\u003e\u003c/0\u003e.","agreement_accept":"Accept","agreement_iot_cn_text_for_startup":"欢迎使用 {app_name} ! 您可以使用本应用实现智能设备的添加、控制、使用和管理等功能。在您开始使用本应用前，请您务必仔细阅读、充分理解\u003c0\u003e{agreement_name}\u003c/0\u003e各条款，该政策概述了我们如何收集使用您的个人信息","mega_agreement_update_text_for_allapp":"We\u0027ve revised our \u003c0\u003e{agreement_name}\u003c/0\u003e. By continuing to use our services, you acknowledge and agree to our terms and policies. Please take a few minutes to review and understand them.","agreement_got_it":"Got it","agreement_text_for_secondary_confirm":"Please read and agree to our terms and conditions, or you will not be able to continue using our app.","mega_agreement_update_title":"Terms and Conditions Update","agreement_general_text_for_allapp":"Welcome to our App! Before you start using our App, please take a moment to review our  \u003c0\u003e{agreement_name}\u003c/0\u003e. Our Anker Innovations Privacy Policy explains what information we collect, how we use it, and how we share it. Our Terms of Use  govern your use of our app. By clicking \"Accept\", you consent to our policies and acknowledge that you have read and understood it. If you do not agree to these terms, you may not use our App.","agreement_update_title":"Terms and Conditions Update","agreement_ignore":"Remind me later","agreement_iot_continue_text_for_allapp":"We take your privacy seriously and are committed to protecting your personal information. \nAs part of our efforts to comply with privacy regulations, we would like to inform you that you have added a device to our App. To continue using our App, we kindly request that you review and agree to the \u003c0\u003e{agreement_name}\u003c/0\u003e. This policy describes how our App handles data from your devices. \nBy clicking \"Accept\", you consent to our policy and acknowledge that you have read and understood it.","agreement_iot_new_text_for_allapp":"Before you add a device, please read the  \u003c0\u003e{agreement_name}\u003c/0\u003e. This policy describes how our App handles data from your devices. By clicking \"Accept\", you consent to our policy and acknowledge that you have read and understood it.","agreement_log_in":"By continuing, you agree to the \u003c0\u003e{agreement_name}\u003c/0\u003e."},"agreement_list":[{"agreement_url":"https://d7p3a6aivdrwg.cloudfront.net/anker_general/public/agreement/2024/12/13/privacy_notice_en.html","country":"global","agreement_id":"1933a3c7-03b2-4cc7-b966-ed9501734a20","updated_at":1723535191,"group_id":"eufy_mega_privacy_policy","agreement_name":"Privacy Notice","created_at":1723535191,"remark":"","version":"1.0.0","must_sign":1},{"agreement_url":"https://d7p3a6aivdrwg.cloudfront.net/anker_general/public/agreement/2024/12/13/terms_of_use_en.html","country":"global","agreement_id":"ce05bf65-182d-411f-bc1f-14abcd928e5f","updated_at":1690168207,"group_id":"terms_of_use","agreement_name":"Terms of use","created_at":1690168207,"remark":"","version":"1.0.0","must_sign":1}]}
  return Promise.resolve(JSON.stringify(data))
}

export function getAppReferralInfo() {
  console.log("call getAppReferralInfo mock native")
  const data = {"volcengine_copywriting":{"agreement_decline":"Decline","agreement_update_text_for_allapp":"We\u0027ve revised our \u003c0\u003e{agreement_name}\u003c/0\u003e. By continuing to use our services, you acknowledge and agree to our terms and policies. Please take a few minutes to review and understand them.","agreement_sign_up":"I agree to the \u003c0\u003e\u003c0\u003e{agreement_name}\u003c/0\u003e\u003c/0\u003e.","agreement_accept":"Accept","agreement_iot_cn_text_for_startup":"欢迎使用 {app_name} ! 您可以使用本应用实现智能设备的添加、控制、使用和管理等功能。在您开始使用本应用前，请您务必仔细阅读、充分理解\u003c0\u003e{agreement_name}\u003c/0\u003e各条款，该政策概述了我们如何收集使用您的个人信息","mega_agreement_update_text_for_allapp":"We\u0027ve revised our \u003c0\u003e{agreement_name}\u003c/0\u003e. By continuing to use our services, you acknowledge and agree to our terms and policies. Please take a few minutes to review and understand them.","agreement_got_it":"Got it","agreement_text_for_secondary_confirm":"Please read and agree to our terms and conditions, or you will not be able to continue using our app.","mega_agreement_update_title":"Terms and Conditions Update","agreement_general_text_for_allapp":"Welcome to our App! Before you start using our App, please take a moment to review our  \u003c0\u003e{agreement_name}\u003c/0\u003e. Our Anker Innovations Privacy Policy explains what information we collect, how we use it, and how we share it. Our Terms of Use  govern your use of our app. By clicking \"Accept\", you consent to our policies and acknowledge that you have read and understood it. If you do not agree to these terms, you may not use our App.","agreement_update_title":"Terms and Conditions Update","agreement_ignore":"Remind me later","agreement_iot_continue_text_for_allapp":"We take your privacy seriously and are committed to protecting your personal information. \nAs part of our efforts to comply with privacy regulations, we would like to inform you that you have added a device to our App. To continue using our App, we kindly request that you review and agree to the \u003c0\u003e{agreement_name}\u003c/0\u003e. This policy describes how our App handles data from your devices. \nBy clicking \"Accept\", you consent to our policy and acknowledge that you have read and understood it.","agreement_iot_new_text_for_allapp":"Before you add a device, please read the  \u003c0\u003e{agreement_name}\u003c/0\u003e. This policy describes how our App handles data from your devices. By clicking \"Accept\", you consent to our policy and acknowledge that you have read and understood it.","agreement_log_in":"By continuing, you agree to the \u003c0\u003e{agreement_name}\u003c/0\u003e."},"agreement_list":[{"agreement_url":"https://d7p3a6aivdrwg.cloudfront.net/anker_general/public/agreement/2024/12/13/privacy_notice_en.html","country":"global","agreement_id":"1933a3c7-03b2-4cc7-b966-ed9501734a20","updated_at":1723535191,"group_id":"eufy_mega_privacy_policy","agreement_name":"Privacy Notice","created_at":1723535191,"remark":"","version":"1.0.0","must_sign":1},{"agreement_url":"https://d7p3a6aivdrwg.cloudfront.net/anker_general/public/agreement/2024/12/13/terms_of_use_en.html","country":"global","agreement_id":"ce05bf65-182d-411f-bc1f-14abcd928e5f","updated_at":1690168207,"group_id":"terms_of_use","agreement_name":"Terms of use","created_at":1690168207,"remark":"","version":"1.0.0","must_sign":1}]}
  return Promise.resolve(JSON.stringify(data))
}

